export default __webpack_public_path__ + "static/media/img_success.3160c20c.png";